import React, { useCallback, useState } from "react";
import { v4 as uuid } from "uuid";
import _ from "lodash"

import "../index.css"
import { getMaterialMasterByCompanyERPCode, getVMIMaterialsByCompanyERPCode } from "../../../services/api/materialMaster";
import { ThreeDots } from "react-loader-spinner";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { useDispatch } from "react-redux";
import { Button, TextInputField } from "../../../helpers";

const MaterialSearch = (props) => {
    const {products, setProducts, companyERPCodeMaps, uomsData, companyId, requirement} = props

    const [productSearch, setProductSearch] = useState('')
    const [selectedProducts, setSelectedProducts] = useState([])
    const [materialSearchLoading, setMaterialSearchLoading] = useState(false)

    const dispatch = useDispatch()

    const handleMaterialSearch = async (e) => {
        setProductSearch(e.target.value)
        handleMaterialMasterDebounceSearch(e.target.value)
    }

    const handleMaterialMasterDebounceSearch = useCallback(_.debounce(async function (searchText) {
        setMaterialSearchLoading(true)
        if(!searchText){
            setSelectedProducts([])
            setMaterialSearchLoading(false)
            return
        }

        let materialRes = null
        if(requirement.reqTagId === 4){
            materialRes = await getVMIMaterialsByCompanyERPCode({
                searchText, 
                companyId: requirement.companyId, 
                warehouseIds: [requirement.pmWarehouseId],
                searchAllMaterials: (requirement.orderTypeId === 3 && requirement.reqTagId === 4) ? true : false
            })
        }
        else{
            materialRes = await getMaterialMasterByCompanyERPCode({searchText, companyId, excludeVMIMaterials: true, excludeTempMaterialsUnderDiffClientReq: true})
        }
        if(materialRes.failure){
            setMaterialSearchLoading(false)
            setSelectedProducts([])
            return dispatch(raiseToast({ severity: 'error', summary: 'materialRes', detail: materialRes.data.error, life: 3000 }))
        }

        setSelectedProducts(materialRes.data)
        setMaterialSearchLoading(false)
    }, 1000), [])

    const handleAddClick = (materialId) => {
        let relatedMaterial = selectedProducts?.find(eachProduct => eachProduct?.materialId === materialId)

        if(!relatedMaterial?.UOMValue && relatedMaterial?.materialId.toString().length >= 7){
            relatedMaterial.UOMValue = 1
        }

        const mappedProduct = companyERPCodeMaps.find(eachERPCodeMap => eachERPCodeMap.materialId === materialId)

        const relatedUOM = uomsData.find(eachUOM => eachUOM.UOM === relatedMaterial.UOM)

        let newProduct = {}
        if(mappedProduct){
            newProduct = {
                productId: uuid(),
                materialId: relatedMaterial.materialId,
                companyERPCode: mappedProduct.companyERPCode,
                productName: mappedProduct?.companyProdName,
                variantName: relatedMaterial.variantName,
                specification: mappedProduct.companyProdSpec,
                brandId: relatedMaterial.brandId,
                categoryId: relatedMaterial.categoryId,
                quantity: '',
                materialUOMId: relatedUOM.materialUOMId,
                uomValue: relatedMaterial.UOMValue,
                isMappedProduct: true,
                buyerRateContractId: null,
                companyERPCodeMapId: mappedProduct.companyERPCodeMapId
            }
        }else{
            newProduct = {
                productId: uuid(),
                companyERPCode: null,
                materialId: relatedMaterial.materialId,
                productName: relatedMaterial?.productName ? `${relatedMaterial?.productName}${relatedMaterial?.variantName ? `-${relatedMaterial?.variantName}` : ''}` : '',
                materialMasterProductName: `${relatedMaterial.productName}-${relatedMaterial.variantName}`,
                materialMasterSpecification: relatedMaterial.productSpecification,
                specification: relatedMaterial.productSpecification,
                brand: relatedMaterial.brandId,
                category: relatedMaterial.categoryId,
                quantity: '',
                materialUOMId: relatedUOM.materialUOMId,
                uomValue: relatedMaterial.UOMValue,
                isMappedProduct: false,
                isMaterialMasterProduct: true,
                buyerRateContractId: null,
                companyERPCodeMapId: null
            }
        }
        const isProductPresent = products.some(eachProduct => eachProduct.productId === newProduct.productId)
        if(!isProductPresent) setProducts([...products, newProduct])
    }

    const materialIds = products.map(eachProduct => eachProduct.materialId)

    return(
        <div className='flex flex-column add-rc-product'>
            <div className='flex flex-column col-12 px-0'>
                <label htmlFor="searchProducts" className="text-sm">Search Product / Specification / Material Code / Company ERP Code</label>
                <TextInputField name="" value={productSearch} labelText="" id="searchProducts" onChange={e => handleMaterialSearch(e)} />
            </div>
            <div className="rc-products-container mb-2">
                {
                    materialSearchLoading ? 
                        <div className="flex justify-content-center align-items-center h-full">
                            <ThreeDots height="50" width="50" radius="5"color="#00baac" ariaLabel="three-dots-loading" visible={true} /> 
                        </div> 
                    :
                    selectedProducts?.length === 0 ? 
                        <p className="flex justify-content-center text-2xl font-medium" style={{color: '#495057'}}>
                            {productSearch ? 'No products found' : 'Please search for products'}
                        </p> 
                        :
                        selectedProducts?.map(eachProduct => {
                            const isProductPresent = products.find(eachPRProduct => eachPRProduct.materialId === eachProduct.materialId) 
                            return (
                                <div key={eachProduct.materialId} className="flex justify-content-between align-items-center pl-3 product-item">
                                    <p>{`${eachProduct?.materialId} | ${eachProduct?.companyERPCode ? `${eachProduct?.companyERPCode} |` : ''} ${eachProduct?.productName} | ${eachProduct?.productSpecification}`}</p>
                                    <Button label={materialIds.includes(eachProduct.materialId) ? "Added" : "Add"} className="w-1 h-2rem mr-2" onClick={() => handleAddClick(eachProduct?.materialId)} disabled={materialIds.includes(eachProduct.materialId) ? true : false} />
                                </div>
                            )
                        })
                }
            </div>
        </div>
    )
}

export default MaterialSearch